module.exports = __webpack_public_path__ + "img/in-as.b678034a.svg";